import React from "react";

import moment from "moment";

import { Anchor, Col, Divider, Row } from "components";

export const PageActivityTab = ({ user }) => (
  <>
    <Row>
      <Col>
        <p className="margin-0">
          <p>MainPage view data is only retained for 90 days, after which it becomes anonymized.</p>
        </p>
      </Col>
    </Row>
    {user.pages.length > 0 && (
      <Row>
        <Col sm={24} md={12}>
          {user.pages.map((item, i) => (
            <Row key={i}>
              <Col>
                <p key={i}>
                  <Anchor href={`${process.env.REACT_APP_FARM_URL}${item.page}`} target="_blank" mixpanelText={item.page}>
                    <b>{item.page}</b>
                  </Anchor>
                  <br />
                  <small>Viewed on {moment.utc(item.date).format("DD.MM.YYYY")}</small>
                </p>
                <Divider />
              </Col>
            </Row>
          ))}
        </Col>
      </Row>
    )}
  </>
);
